{
  "tabs": {
    "chat": "Talanoa",
    "reminders": "Fakamalolo",
    "calendar": "Kalenda",
    "settings": "Fakatonulea"
  },
  "common": {
    "cancel": "Fakamole",
    "save": "Fakatokanga",
    "confirm": "Fakamanatu",
    "delete": "Fakafofonga",
    "back": "Hoki",
    "close": "Tutupā",
    "edit": "Fakatonulea",
    "search": "Kumi",
    "all": "Katoa",
    "loading": "Fakamālohi...",
    "error": "Oku iai ha meʻa ne sai",
    "notFound": "Oku ʻikai ke maʻu",
    "tryAgain": "Kataki fakamahino ke toe fai",
    "retry": "Toe fai",
    "undo": "Foki ki he taimi muʻa",
    "pullToRefresh": "Tāu ke fakafou",
    "justNow": "ʻI he taimi ni"
  },
  "auth": {
    "welcome": "Mālō e lelei ki he FishMemory",
    "tagline": "Ko ho'o tokoni fakamalolo WhatsApp, ʻi ho'o peke.",
    "subtitle": "Ko ho'o tokoni fakamalolo WhatsApp, ʻi ho'o peke.",
    "phoneLabel": "Ko ho'o numela WhatsApp",
    "phoneHint": "Te mau tuku ha code fakamaama ʻi he WhatsApp",
    "invalidPhone": "Kataki fakamahino ha numela telefoni lelei",
    "continue": "Fakaʻaonga",
    "enterPhone": "Fakaʻaonga ho'o numela WhatsApp",
    "phonePlaceholder": "Numela telefoni",
    "sendCode": "Tuku Code",
    "verifyTitle": "Fakamaama ho'o numela",
    "otpSentTo": "Koe code 6-digit naʻe tuku ki {{phone}} ʻi he WhatsApp",
    "enterFullCode": "Kataki fakamahino e ngaahi digit 6 kotoa",
    "invalidOtp": "Code ʻikai ke sai. Kataki fakamahino ke toe fai.",
    "otpFailed": "ʻIkai ke lava tuku code. Toe fai.",
    "otpResent": "Code naʻe tuku foki",
    "resendIn": "Tuku foki ʻi he {{seconds}}s",
    "resendCode": "Tuku foki code",
    "enterOtp": "Fakaʻaonga e code naʻe tuku ki ho'o WhatsApp",
    "verify": "Fakamaama",
    "resend": "Tuku foki code",
    "wrongNumber": "Numela ʻikai ke sai?",
    "backToPhone": "Hoki ki he telefoni",
    "editPhone": "Fakatonulea numela telefoni",
    "error": "Fakamālohi",
    "setupTitle": "Tau fakahoko",
    "setupSubtitle": "Te ke lava ke liliu ʻeni ʻi he taimi ʻe toe ʻosi ʻi he Fakatonulea",
    "namePlaceholder": "Hingoa",
    "letsGo": "Fakaʻosi fakahoko",
    "skipForNow": "Tōlotoʻi ʻi he taimi ni"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Tuhituhi ha fehuʻi...",
    "inputPlaceholder": "Tuhituhi ha fehuʻi...",
    "typing": "Oku toki tohi ʻa FishMemory...",
    "online": "ʻI he initaneti",
    "connecting": "Oku fakafesoʻotaʻi...",
    "reconnecting": "Oku fakafesoʻotaʻi foki...",
    "offline": "ʻIkai ʻi he initaneti",
    "empty": "Fakatāpu ha talanoa",
    "emptyHint": "Fakaʻaonga fakamalolo, vakai ki ho'o kalenda, pe kole tokoni.",
    "emptyAction": "Tuku ha fakamalolo fakataha",
    "actions": "Ngaahi ngāue talanoa",
    "keep": "Fakatauange ngaahi fehuʻi",
    "clearTitle": "Fakafofonga talanoa",
    "clearConfirm": "Fakafofonga kotoa ʻa e ngaahi fehuʻi mei he meʻalele ko ʻeni? ʻOku ʻikai ke toe fakahoko.",
    "clear": "Fakafofonga talanoa",
    "optionSelected": "Naʻe fili: {{label}}",
    "sendingSelection": "Oku tuku...",
    "connectionLost": "Oku fakafesoʻotaʻi foki..."
  },
  "reminders": {
    "title": "ʻOku Fakamalolo ʻEku ʻI He",
    "active": "Oku Ngaue",
    "today": "ʻI he ʻAho Ni",
    "thisWeek": "ʻI he Uike Ni",
    "history": "Talaʻaga",
    "items": "meʻa",
    "emptyTitle": "ʻOku ʻikai ha fakamalolo",
    "emptySubtitle": "Fakaʻaonga mei he talanoa pea ʻe toki ʻi he ʻapi ko ʻeni.",
    "emptyAction": "Tukufakahā talanoa",
    "filterActive": "Oku Ngaue",
    "filterToday": "ʻI he ʻAho Ni",
    "filterWeek": "ʻI he Uike Ni",
    "filterHistory": "Talaʻaga",
    "emptyState": "ʻOku ʻikai ha fakamalolo. Fakatāpu ha talanoa!",
    "swipeDone": "ʻOku ʻosi",
    "swipeSnooze": "Fakamālohi",
    "swipeDelete": "Fakafofonga",
    "search": "Kumi fakamalolo...",
    "upcoming": "Fakaʻosi mai",
    "completed": "ʻOku ʻosi",
    "overdue": "ʻOku ʻi he taimi muʻa",
    "tomorrow": "ʻAtene",
    "synced": "Naʻe fakataha {{value}}",
    "swipeHint": "Swipe ha fakamalolo ke maʻu ha ngāue ange",
    "noResults": "ʻOku ʻikai ha fakamalolo ʻoku fetongi mo ho'o kumi",
    "noResultsHint": "Fakaʻaonga ha kupu kehe pe fakafofonga e kumi",
    "deleteAllFailed": "ʻIkai ke lava fakafofonga kotoa ʻa e ngaahi fakamalolo"
  },
  "calendar": {
    "title": "Kalenda",
    "today": "ʻI he ʻAho Ni",
    "tomorrow": "ʻAtene",
    "completed": "ʻOku ʻosi",
    "noEvents": "ʻIkai ha ngāue",
    "noEventsSubtitle": "Fili ha ʻaho ke vakai ki he ngaahi fakamalolo mo e ngaahi ngāue kalenda.",
    "googleEvent": "Kalenda Google",
    "legendActive": "Oku Ngaue",
    "legendRecurring": "Fakafoki",
    "legendDone": "ʻOku ʻosi",
    "legendGoogle": "Google",
    "previousMonth": "Māhina muʻa",
    "nextMonth": "Māhina ʻaho",
    "previousYear": "Taʻu muʻa",
    "nextYear": "Taʻu ʻaho",
    "goToToday": "Tāu ki he ʻaho ni",
    "all": "Katoa",
    "active": "Oku Ngaue",
    "done": "ʻOku ʻosi",
    "paused": "Tāofi"
  },
  "settings": {
    "title": "Fakatonulea",
    "profile": "Puleʻanga",
    "name": "Hingoa Fakaʻata",
    "enterName": "Fakaʻaonga ho'o hingoa",
    "language": "Lea",
    "uiLanguage": "Lea ʻo e app",
    "uiLanguageHelp": "Fakafoki e lea ʻo e app, ngaahi tohi kalenda, mo e hala layout ʻi he meʻalele ko ʻeni pe.",
    "serverLanguage": "Lea ʻo e talanoa",
    "serverLanguageHelp": "Fakafoki e lea ʻoku ngaue ʻaki ʻe he server ʻi he tali mo e ngaahi fehuʻi fakamalolo ki ho'o account.",
    "timezone": "Taimi fakalakalaka",
    "currentTimezone": "Taimi fakalakalaka ʻoku ʻi he taimi ni",
    "timezoneHelp": "Kotoa e taimi fakamalolo ʻoku fakahā ʻaki ʻeni.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Fakatokanga taimi fakalakalaka",
    "timezoneSaved": "Naʻe fakahou e taimi fakalakalaka",
    "detect": "Fakakite",
    "detectFailed": "ʻIkai ke lava fakakite e taimi fakalakalaka",
    "autoDetect": "Fakakite fakaʻosi mei he GPS",
    "notifications": "Fakamatala",
    "notificationsHelp": "Ngaahi fakamalolo fakaʻosi ʻoku puleʻi e toe fakamatala ʻi he taimi ʻe toe ʻosi e fakamalolo. ʻOku totonu ke puleʻi e ngaahi faingamālie fakamatala ʻi he fakatonulea telefoni.",
    "pushEnabled": "Fakamatala Push",
    "autoDoneOnFire": "Fakaʻosi fakaʻosi ʻi he taimi naʻe fakahoko",
    "autoDoneOnFireDesc": "Kapau ʻikai, ʻoku kei ngaue ʻa e ngaahi fakamalolo ke ʻoku ke fakahā ʻe koe ʻoku ʻosi.",
    "googleCalendar": "Kalenda Google",
    "google": "Kalenda Google",
    "googleConnected": "Naʻe fakafesoʻotaʻi",
    "googleDisconnected": "ʻIkai ke fakafesoʻotaʻi",
    "googleConnectedHelp": "Ngaahi fakamalolo foʻou ʻe lava ke fakataha ki ho'o kalenda fakaʻosi.",
    "googleDisconnectedHelp": "Fakafesoʻotaʻi Kalenda Google ke tauhi fakataha ʻa e ngaahi fakamalolo mo e ngaahi ngāue.",
    "googleConnectFailed": "ʻIkai ke lava fakafesoʻotaʻi Kalenda Google",
    "connected": "Naʻe fakafesoʻotaʻi",
    "disconnected": "ʻIkai ke fakafesoʻotaʻi",
    "connect": "Fakafesoʻotaʻi",
    "disconnect": "Fakaʻikai fakafesoʻotaʻi",
    "autoSync": "Fakafou fakaʻosi ʻa e ngaahi fakamalolo foʻou",
    "autosync": "Fakafou fakaʻosi ʻa e ngaahi fakamalolo foʻou",
    "subscription": "Fakaʻaonga",
    "trialUsed": "Fakaʻaonga: {{used}}/{{total}} fakaʻaonga",
    "trialStatus": "Fakaʻaonga ʻoku maʻu",
    "activeStatus": "Fakaʻaonga ʻoku ngaue",
    "expiredStatus": "Fakaʻaonga ʻoku ʻosi",
    "unsubscribedStatus": "ʻIkai ke fakaʻaonga",
    "about": "Fakamatala",
    "version": "Fakafou",
    "logout": "Tāofi",
    "logoutTitle": "Tāofi",
    "logoutConfirm": "ʻOku ke ʻi he loto ke tāofi?",
    "noName": "ʻIkai ha hingoa",
    "serverConnection": "Fakafesoʻotaʻi server",
    "serverUrl": "URL server",
    "serverEdit": "Fakatonulea",
    "saveReconnect": "Fakatokanga pea fakafesoʻotaʻi foki",
    "resetDefault": "Fakafofonga ki he taimi muʻa",
    "invalidServerUrlTitle": "URL server ʻikai ke sai",
    "invalidServerUrlMessage": "Fakaʻaonga ha URL server http pe https lelei, hange ko https://example.com",
    "uiLanguageChangeFailed": "ʻIkai ke lava liliu e lea ʻo e app. Kataki fakamahino ke toe fai.",
    "serverLanguageChangeFailed": "ʻIkai ke lava liliu e lea ʻo e talanoa. Kataki fakamahino ke toe fai.",
    "timezoneChangeFailed": "ʻIkai ke lava liliu e taimi fakalakalaka. Kataki fakamahino ke toe fai.",
    "autoSyncChangeFailed": "ʻIkai ke lava fakahou e fakafou fakaʻosi. Kataki fakamahino ke toe fai.",
    "nameChangeFailed": "ʻIkai ke lava fakahou e hingoa fakaʻata. Kataki fakamahino ke toe fai.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Ngaahi fakamatala fakamalolo",
    "editTime": "Fakatonulea Taimi",
    "rename": "Liliu hingoa",
    "snooze": "Fakamālohi",
    "snooze15": "Fakamālohi he 15 miniti",
    "pause": "Tāofi",
    "pauseReminder": "Tāofi fakamalolo",
    "resume": "Fakamālohi",
    "resumeReminder": "Fakamālohi fakamalolo",
    "skip": "Tōlotoʻi ʻi he taimi ʻaho ʻe taha",
    "skipOccurrence": "Tōlotoʻi ʻi he taimi ko ʻeni",
    "syncGoogle": "Fakafou ki Google",
    "delete": "Fakafofonga",
    "deleteTitle": "Fakafofonga Fakamalolo",
    "deleteConfirm": "Koe fakamalolo ko ʻeni ʻe fakafofonga ʻi he taimi kotoa.",
    "deleteRecurringTitle": "Fakafofonga Fakamalolo Fakafoki",
    "deleteRecurringMessage": "Oku ke fie tōlotoʻi ʻi he taimi ko ʻeni pe fakafofonga ʻi he ngaahi taimi kotoa?",
    "deleteThisOccurrence": "Tōlotoʻi ʻi he taimi ko ʻeni",
    "deleteEntireSeries": "Fakafofonga ngaahi taimi kotoa",
    "done": "ʻOku ʻosi",
    "markDone": "Fakahā ko ʻoku ʻosi",
    "undo": "Foki ki he taimi muʻa",
    "undoPrompt": "Fie ke toe ngaue? Foki ki he taimi ni.",
    "recurring": "Fakafoki",
    "nextRun": "Taimi ʻaho ʻe taha",
    "oneTime": "Taimi taha",
    "pending": "Oku kei toki",
    "sent": "Naʻe tuku",
    "paused": "Tāofi",
    "active": "Oku Ngaue",
    "snoozed": "Naʻe fakamālohi",
    "localTime": "Fakahā ʻi ho'o taimi fakalakalaka",
    "recurrence": "Fakafoki",
    "created": "Naʻe hanga",
    "tags": "Ngaahi tohi",
    "fireCount": "Ngaahi taimi naʻe fakahoko",
    "actions": "Ngaahi ngāue",
    "none": "ʻIkai ha",
    "snoozeFailed": "ʻIkai ke lava fakamālohi fakamalolo",
    "pauseFailed": "ʻIkai ke lava tāofi fakamalolo",
    "resumeFailed": "ʻIkai ke lava fakamālohi fakamalolo",
    "skipFailed": "ʻIkai ke lava tōlotoʻi fakamalolo",
    "doneFailed": "ʻIkai ke lava fakahā ko ʻoku ʻosi fakamalolo",
    "undoFailed": "ʻIkai ke lava foki ki he taimi muʻa fakamalolo",
    "deleteFailed": "ʻIkai ke lava fakafofonga fakamalolo",
    "rescheduleTitle": "Fakahoko foki?",
    "rescheduleMsg": "Koe fakamalolo ko ʻeni ʻoku ʻi he taimi muʻa. ʻOku ke fie fakahoko foki?",
    "reschedule15": "ʻI he 15 miniti",
    "reschedule60": "ʻI he 1 houa",
    "keepOverdue": "Tauhi pē"
  },
  "onboarding": {
    "slide1Title": "Mālō e lelei ki he FishMemory",
    "slide1Sub": "Ko ho'o tokoni fakamalolo fakaʻaho - naʻe fakahoko ʻe WhatsApp pea ʻi he peke.",
    "slide2Title": "Talanoa pē ke maʻu",
    "slide2Sub": "Tuhituhi fakamalolo hange ko ho'o manatu: \"Fakamalolo au ke telefoni ki e mātuʻa ʻapongipongi he 3pm\" — tau tokoni ki he ngaahi meʻa kehekehe.",
    "slide3Title": "ʻIkai ke mou maʻu ha meʻa",
    "slide3Sub": "Maʻu fakamatala ʻi he taimi lelei, fakataha ʻaki e ngaahi tohi, pea tauhi lelei ʻa e ngaahi meʻa kotoa.",
    "getStarted": "Fakaʻaonga",
    "next": "Lahi ange",
    "firstReminderTitle": "Hanga ho'o fakamalolo ʻa e taimi muʻa!",
    "firstReminderHint": "Fakaʻaonga ha meʻa hange ko:",
    "firstReminderExample": "Fakamalolo au ke inu vai ʻapongipongi he 9 AM",
    "gotIt": "ʻIlo!",
    "notifRationaleTitle": "Tauhi ʻi he taimi",
    "notifRationaleBody": "Oku fiemaʻu ʻa e FishMemory ʻa e ngaahi fakamatala ke fakamalolo koe ʻi he taimi. ʻE maʻu pē koe ngaahi fakamatala ki he ngaahi fakamalolo ko ʻeni.",
    "notifRationaleAllow": "Fakatāpu Fakamatala",
    "notifRationaleLater": "Fakakaukau ʻi he taimi ʻe toe ʻosi",
    "swipeHint": "Swipe ki he mataʻukepau ke maʻu ha ngāue vave →",
    "calendarDragHint": "Tāu ke fakalahi ↕"
  }
}
